<template>
  <base-modal
    :title="informationTitle"
    :hasMainBtn="false"
    :customShowDialog="showInformationModal"
    @close="handleClose"
  >
    <div slot="body">
      <span class="modal-text" v-html="informationBody"></span>
    </div>
  </base-modal>
</template>

<script>
export default {
  name: 'information-modal',
  components: {BaseModal: () => import('./BaseModal')},
  computed: {
    showInformationModal: { get () { return this.$store.state.modalState.showInformationModal } },
    informationTitle: { get () { return this.$store.state.notificationState.informationTitle } },
    informationBody: { get () { return this.$store.state.notificationState.informationBody } }
  },
  methods: {
    handleClose () {
      this.$store.commit('setShowInformationModal', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/InformationModal.vue